import { OrderedMap, fromJS, Iterable } from 'immutable';
import AdStateContainerRecord from 'PreviewRecords/AdStateContainerRecord';
import LayoutRecord from 'PreviewRecords/LayoutRecord';

/* eslint-disable consistent-return */
export function reviveAdStateContainers(adStateContainers) {
  return new OrderedMap(fromJS(adStateContainers, (key, value) => {
    if (key === 'dimensions') { return value.toMap(); }

    if (key !== '') {
      return new AdStateContainerRecord({
        key: value.get('key'),
        artboard: value.get('artboard'),
        isFixed: value.get('isFixed'),
        dimensions: value.get('dimensions'),
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}

export function reviveLayouts(layouts) {
  return new OrderedMap(fromJS(layouts, (key, value) => {
    if (key === 'backgroundDimensions') {
      return value.toList();
    }
    if (key === 'adStateContainers') {
      return value.toList();
    }

    if (key !== '') {
      return new LayoutRecord({
        key: value.get('key'),
        id: value.get('id'),
        name: value.get('name'),
        device: value.get('device'),
        inApp: value.get('inApp'),
        deviceHeader: value.get('deviceHeader'),
        background: value.get('background'),
        backgroundFileName: value.get('backgroundFileName'),
        backgroundAlign: value.get('backgroundAlign'),
        backgroundDimensions: value.get('backgroundDimensions'),
        backgroundMonochrome: value.get('backgroundMonochrome'),
        backgroundOpacity: value.get('backgroundOpacity'),
        adStateContainers: value.get('adStateContainers'),
        isCustom: value.get('isCustom'),
        hasChanged: false,
      });
    }
    const isIndexed = Iterable.isIndexed(value);
    return isIndexed ? value.toList() : value.toOrderedMap();
  }));
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/records/revivers.js